import type { EventsMap } from './events.js';
import type { PluginsInterface } from './plugins-interface.js';

// Event Emitter that is exposed to the user.
// Only basic functionality, currently there is no reason for user to touch `emit` or `events`.
// It also is used to keep plugin name in closure in case errors will happen in events.
export class UserEventWrapper {
  readonly #pluginsInterface: PluginsInterface;
  readonly #pluginName: string;

  constructor(pluginsInterface: PluginsInterface, pluginName: string) {
    this.#pluginsInterface = pluginsInterface;
    this.#pluginName = pluginName;
  }

  on<K extends keyof EventsMap>(
    key: K,
    callback: (data: EventsMap[K]) => void | Promise<void>
  ) {
    return this.#pluginsInterface.eventsEmitter.on(key, async (data) => {
      try {
        await callback(data);
      } catch (e) {
        this.#pluginsInterface.onPluginError?.(e, {
          handlerName: key,
          pluginName: this.#pluginName,
        });
      }
    });
  }
}
